import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { Box, Button, HStack, Input, InputGroup, InputRightElement, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

const ReplaceCertForm = ({ executeAction, cancel, action }) => {
  const [replaceCertNumber, setReplaceCertNumber] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [inputType, setInputType] = useState('text');

  useEffect(() => {
    if (!showPass) {
      setInputType('password');
    } else {
      setInputType('text');
    }
  }, [showPass]);

  return (
    <Box>
      <Box mt={6} border="1px solid #E53E3E" borderRadius="md" borderStyle="dashed" p={4}>
        <Text fontSize="sm" color="blue" mb={1.5}>
          Enter the certificate number you want to assign to this mill.
        </Text>

        <Input
          h="50px"
          isRequired
          bg="secondary"
          type="number"
          variant="outline"
          borderRadius="2px"
          autoComplete="off"
          focusBorderColor="primary.300"
          onChange={(e) => setReplaceCertNumber(e.target.value)}
        />

        <Text fontSize="sm" color="invalid" mb={1.5}>
          * Enter your password to confirm you want to {action?.toLowerCase() || 'reject'} this
          certificate
        </Text>
        <InputGroup>
          <InputRightElement>
            {showPass ? (
              <ViewIcon onClick={() => setShowPass(false)} cursor="pointer" mt={1.5} />
            ) : (
              <ViewOffIcon onClick={() => setShowPass(true)} cursor="pointer" mt={1.5} />
            )}
          </InputRightElement>
          <Input
            h="50px"
            isRequired
            bg="secondary"
            type={inputType}
            variant="outline"
            borderRadius="2px"
            autoComplete="off"
            focusBorderColor="primary.300"
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputGroup>
        <HStack mt={4} justifyContent="right">
          <Button variant="modalAction" onClick={cancel}>
            CANCEL
          </Button>
          <Button
            bg="red.500"
            variant="modalAction"
            _hover={{ bg: 'red.400' }}
            isDisabled={replaceCertNumber?.length < 1 || password?.length < 6}
            onClick={() => {
              executeAction(replaceCertNumber, password);
            }}>
            CONFIRM
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};

export default ReplaceCertForm;
